import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    DialogContent,
    MenuItem,
    FormControlLabel,
    Checkbox,
    InputAdornment,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import { initialValues, validationSchemaValidOrderServices } from '../validDataFormValidationSchema';
import { ValidDataService } from '../../../../service/validDataService';

export default function editValidOrderServiceForm({ open, onClose, onRecordEdit, validOrder }) {

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const response = await ValidDataService.addValidServices({ ...values });
            const { code, data, message } = response;
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordEdit(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.log(error);
            }
            toast.error('Failed to update record');
        }
    };

    return (
        <DraggableDialog title={"Add Services"} onClose={onClose} open={open} width={'lg'}>
            <DialogContent>
                <Formik
                    initialValues={{ ...initialValues, ...validOrder }}
                    validationSchema={validationSchemaValidOrderServices}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, touched, isValid }) => (
                        <Form>

                            <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                                <Grid item xs={6}>
                                    <Field
                                        as={TextField}
                                        name='name'
                                        label="Name"
                                        required
                                        fullWidth

                                    />
                                    <ErrorMessage name='name'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        as={TextField}
                                        name='cost'
                                        label="Cost"
                                        required
                                        fullWidth
                                    />
                                    <ErrorMessage name='cost'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControlLabel
                                        control={
                                            <Field
                                                as={Checkbox}
                                                name='isTaxable'
                                                type="checkbox"
                                                checked={values.isTaxable}
                                            />
                                        }
                                        label="Is Taxable"
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <Field
                                        as={TextField}
                                        name='defaultTaxPercentage'
                                        label="Tax Percentage"
                                        fullWidth
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                    <ErrorMessage name='defaultTaxPercentage'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={2}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        select
                                        required
                                        fullWidth
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                            </Grid>
                            {
                                isSubmitting ? 'Saving...' : <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={!isValid}
                                >
                                    Save
                                </Button>
                            }
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog >
    );
};